import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'

import { TOKEN_HELPERS, sortByKey, filterBodyBuilder, handleClickPaginationItem } from '@utils/helpers'
import { rowsPerPage, TOAST_PROPERTIES, TOAST_POSITION, TRANSLATION_OF_ROUTES } from '@global/constants'
import { SITE } from '@routes/paths'
import {
  WrapperBreadcrumbs,
  WrapperLoading,
  FilterContainer,
  FilterContainerLeftSide,
  FilterContainerRightSide,
  WrapperHeading,
  TableWrapper,
  PaginationWrapper
} from '@global/styles'

import { Heading } from '@components/texts'
import { GhostButton } from '@components/button'
import { useWindowDimensions } from '@components/windowDimensions'
import Breadcrumbs from '@components/breadcrums'
import { useUser } from '@components/authentication/utils/hook'
import Toast from '@components/toast'
import Table from '@components/table'
import Filter from '@components/filter'
import Badge from '@components/badge'
import Loading from '@components/loading'
import Modal from '@components/modal'
import BadgeGroup from '@components/badgeGroup'
import SearchBar from '@components/searchBar'
import PaginationGroup from '@components/paginationGroup'

import SELECTORS_USER from '@components/authentication/redux/selectors'

import useRedux from './redux'
import { USERS_ACTIONS } from './redux/actions'
import SELECTORS from './redux/selectors'
import AddUserModal from './components/addUserModal'

import { Wrapper } from './styles'

import { options, columnData } from './data'

const Users = () => {
  useRedux()
  const { device, deviceName } = useWindowDimensions()
  const dispatch = useDispatch()
  const history = useHistory()
  const { GetToken, Logout } = useUser()

  const [currentToken] = useState(GetToken())
  const [breadcrumbs, setBreadcrumbs] = useState([])
  const [selectedOption, setSelectedOption] = useState(options[0])
  const [itemSelected, setItemSelected] = useState()
  const [pages, setPages] = useState()
  const [totalItems, setTotalItems] = useState(0)
  const [tablelist, setTablelist] = useState([])
  const [columns, setColumns] = useState([])
  const [isShowing, setIsShowing] = useState(false)
  const [open, setOpen] = useState(false)
  const [showFilter, setShowFilter] = useState(false)
  const [messageToast, setMessageToast] = useState({
    title: '',
    message: '',
    icon: '',
    color: ''
  })
  const [badges, setBadges] = useState([])
  const [filterData, setFilterData] = useState([])
  const [activeFilters, setActiveFilters] = useState(null)
  const [addUserModal, setAddUserModal] = useState(false)
  const [errorFlag, setErrorFlag] = useState(false)
  const [statuses, setStatuses] = useState({
    statuses: false,
    users: false
  })
  const [parameters, setParameters] = useState()

  const loading = useSelector(SELECTORS.LOADING)
  const statusesData = useSelector(SELECTORS.STATUSES)
  const usersLoading = useSelector(SELECTORS.USERS_LOADING)
  const totalPages = useSelector(SELECTORS.PAGES)
  const items = useSelector(SELECTORS.SUCCESS)
  const fields = useSelector(SELECTORS.COLUMNS)
  const allItems = useSelector(SELECTORS.TOTAL_ITEMS)
  const errorMessageStatuses = useSelector(SELECTORS.ERROR_STATUSES)
  const usersError = useSelector(SELECTORS.USERS_ERROR)
  const filterObject = useSelector(SELECTORS.FILTER_OBJECT)
  const errorRefresh = useSelector(SELECTORS_USER.ERROR_USER_REFRESH)

  const getStatusesData = () => {
    dispatch(USERS_ACTIONS.CLEAR())
    const { token, tokenCreationDate } = currentToken
    const { isValid, error } = TOKEN_HELPERS.IS_VALID_TOKEN(tokenCreationDate)
    if (isValid) {
      dispatch(USERS_ACTIONS.GET_STATUSES(token))
    } else TOKEN_HELPERS.EXPIRED_TOKEN(error, setIsShowing, setMessageToast, Logout)
  }

  const getUsers = body => {
    const { token, tokenCreationDate } = currentToken
    const { isValid, error } = TOKEN_HELPERS.IS_VALID_TOKEN(tokenCreationDate)
    if (isValid) {
      dispatch(USERS_ACTIONS.GET({ data: body, token }))
    } else TOKEN_HELPERS.EXPIRED_TOKEN(error, setIsShowing, setMessageToast, Logout)
  }

  const handleInputChange = e => {
    if (!e?.value) delete activeFilters.filterText

    let body = activeFilters ? { ...activeFilters } : {}

    if (e?.value) {
      body = { ...body, filterText: e.value }
      setActiveFilters({
        ...activeFilters,
        filterText: e.value
      })
    }
    getUsers(body)
  }

  const handleClickCloseFilters = () => {
    dispatch(USERS_ACTIONS.FILTER_DATA_CLEAR())
    setShowFilter(!showFilter)
  }

  const handleClickShowFilters = () => {
    const { token, tokenCreationDate } = currentToken
    const { isValid, error } = TOKEN_HELPERS.IS_VALID_TOKEN(tokenCreationDate)
    if (isValid) {
      // search id in endpoint  Filter/list
      const filterRequest = { id: 4, token }
      dispatch(USERS_ACTIONS.GET_FILTER_DATA(filterRequest))
      setShowFilter(!showFilter)
    } else TOKEN_HELPERS.EXPIRED_TOKEN(error, setIsShowing, setMessageToast, Logout)
  }

  const customHeaderDataTable = (headersData, colData) => {
    const orderedColumns = sortByKey(headersData, 'order').map(col => col.name)
    let customColumns = []
    for (let i = 0; i < orderedColumns.length; i++) {
      const wanted = Object.entries(colData).find(item => item[0] === orderedColumns[i])
      customColumns = [
        ...customColumns,
        wanted[1]
      ]
    }

    return customColumns
  }

  const customBodyDataTable = bodyData => {
    const newData = bodyData.map(item => {
      const { status } = item
      let statusName = ''
      if (status) {
        statusName = status
      } else {
        statusName = statuses ? statuses.find(s => s.id === item?.id) : 'N/A'
      }

      let newItem = item
      const statusBadge = (
        <Badge
          text={statusName}
          color='system'
          backgroundColor='secondary'
          size='small'
        />
      )

      newItem = {
        ...newItem,
        status: statusBadge
      }
      return newItem
    })
    return newData
  }

  const handleOrderChange = (nameColumn, typeOrder) => {
    const colNames = Object.entries(columnData).find(col => col[1].name === nameColumn)
    const body = {
      pageNumber: itemSelected + 1,
      pageSize: selectedOption.value,
      orderByColumn: colNames[0],
      orderByDesc: typeOrder
    }
    getUsers(body)
  }

  const handleCloseBadge = filterName => {
    const updateBadges = badges.filter(badge => badge.name !== filterName)
    setBadges(updateBadges)
    const body = filterBodyBuilder(updateBadges, selectedOption.value, setActiveFilters, activeFilters, parameters)
    getUsers(body)
  }

  const handleApplyFilter = filters => {
    setBadges(filters)
    const body = filterBodyBuilder(filters, selectedOption.value, setActiveFilters, activeFilters, parameters)
    getUsers(body)
  }

  const getUser = id => {
    history.push(`${SITE.SETTING}${SITE.USERS}${SITE.USER}/${id}`)
  }
  const handleRowClick = rowObj => getUser(rowObj.id)

  const handleToastClose = () => setIsShowing(false)

  const handleDropdownChange = e => {
    let body = null
    if (activeFilters) {
      body = { ...activeFilters }
      body = {
        ...body,
        pageNumber: 1,
        pageSize: e.value.value
      }
    } else {
      body = {
        pageNumber: 1,
        pageSize: e.value.value
      }
    }
    getUsers(body)
    setSelectedOption(e.value)
    setItemSelected(0)
  }

  const handleAddDataUser = () => {
    dispatch(USERS_ACTIONS.CLEAR())
    const body = { pageNumber: 1, pageSize: selectedOption.value }
    getUsers(body)
  }

  const renderTable = values => {
    const { currentList, columnsN, currentLoading, handleOrder, handleSelectedRow, error, showRowPointer } = values
    return (
      <Table
        list={currentList}
        columns={columnsN}
        loading={currentLoading}
        handleOrder={handleOrder}
        rowClick={handleSelectedRow}
        error={error}
        showRowPointer={showRowPointer}
        timeDate
      />
    )
  }

  const renderFilter = arrFilters => (
    <Filter
      device={device}
      close={handleClickCloseFilters}
      loadBadges={handleApplyFilter}
      filterData={arrFilters}
      isShowing={showFilter}
    />
  )

  const handleCloseModal = () => {
    setOpen(false)
    setAddUserModal(null)
  }

  const handleCreateUser = () => {
    setAddUserModal({
      close: handleCloseModal,
      saveData: handleAddDataUser,
      currentToken
    })
    setOpen(true)
  }

  useEffect(() => {
    getStatusesData()
  }, [])

  useEffect(() => {
    if (statusesData) {
      setStatuses(statusesData)
      const body = { pageNumber: 1, pageSize: selectedOption.value }
      getUsers(body)
    }
  }, [statusesData])

  useEffect(() => {
    setTablelist(customBodyDataTable(items))
    setColumns(customHeaderDataTable(fields, columnData))
    setPages(totalPages.totalPages)
    setItemSelected(totalPages.currentPage - 1)
    setTotalItems(allItems)
    const firstCrumb = {
      text: TRANSLATION_OF_ROUTES.SETTING,
      link: true,
      url: SITE.SETTING
    }
    const secondCrumb = {
      text: TRANSLATION_OF_ROUTES.USERS,
      link: true,
      url: SITE.USERS
    }
    setBreadcrumbs([firstCrumb, secondCrumb])
  }, [items, totalPages])

  useEffect(() => {
    if (errorMessageStatuses) {
      setMessageToast({
        title: TOAST_PROPERTIES.ERROR.title,
        message: errorMessageStatuses.message || `Error ${errorMessageStatuses.status}`,
        icon: TOAST_PROPERTIES.ERROR.icon,
        color: TOAST_PROPERTIES.ERROR.color
      })
      setIsShowing(true)
      if (!errorFlag.statuses) {
        getStatusesData()
        setErrorFlag({
          ...errorFlag,
          statuses: true
        })
      } else {
        setTimeout(() => {
          history.goBack()
        }, 1500)
      }
    }
  }, [errorMessageStatuses])

  useEffect(() => {
    if (usersError) {
      setMessageToast({
        title: TOAST_PROPERTIES.ERROR.title,
        message: usersError.message || `Error ${usersError.status}`,
        icon: TOAST_PROPERTIES.ERROR.icon,
        color: TOAST_PROPERTIES.ERROR.color
      })
      setIsShowing(true)
      if (!errorFlag.users) {
        const body = { pageNumber: 1, pageSize: selectedOption.value }
        getUsers(body)
        setErrorFlag({
          ...errorFlag,
          users: true
        })
      } else {
        setTimeout(() => {
          history.goBack()
        }, 1500)
      }
    }
  }, [usersError])

  useEffect(() => {
    if (filterObject.length > 0) {
      setFilterData(filterObject)
      setParameters(filterObject.map(p => p.name))
    }
  }, [filterObject])

  useEffect(() => {
    if (errorRefresh) {
      TOKEN_HELPERS.EXPIRED_TOKEN(errorRefresh.message, setIsShowing, setMessageToast, Logout)
    }
  }, [errorRefresh])

  return (
    <>
      {loading
        ? (
          <WrapperLoading>
            <Loading color='primary' size='xsmall' weight='bold' />
          </WrapperLoading>
        )
        : (
          <Wrapper>
            {breadcrumbs
              && (
              <WrapperBreadcrumbs>
                <Breadcrumbs crumbs={breadcrumbs} />
              </WrapperBreadcrumbs>
              )}
            <WrapperHeading columnStart='1' columnEnd='12' rowStart='2' rowEnd='2'>
              <Heading
                type='h2'
                weight='bold'
                align='left'
              >
                {TRANSLATION_OF_ROUTES.USERS}
              </Heading>
            </WrapperHeading>
            <FilterContainer columnStart={1} columnEnd={12} rowStart={3} rowEnd={3} deviceName={deviceName}>
              <FilterContainerLeftSide deviceName={deviceName}>
                <GhostButton
                  color='tertiary'
                  size='small'
                  text='Agregar Filtro'
                  icon='filter_alt'
                  onClick={handleClickShowFilters}
                />
                {badges.length > 0 && <BadgeGroup badges={badges} handleCloseBadge={handleCloseBadge} />}
                {showFilter && (filterData.length > 0 && renderFilter(filterData))}
              </FilterContainerLeftSide>
              <FilterContainerRightSide deviceName={deviceName}>
                <SearchBar onChange={handleInputChange} value={activeFilters?.filterText} />
                <GhostButton
                  color='tertiary'
                  size='small'
                  text='Agregar Usuario'
                  icon='add'
                  onClick={handleCreateUser}
                />
              </FilterContainerRightSide>
            </FilterContainer>
            <TableWrapper rowStart='4' rowEnd='4' columnStart='1' columnEnd='12'>
              {renderTable({
                currentList: tablelist,
                columnsN: columns,
                currentLoading: usersLoading,
                handleOrder: handleOrderChange,
                handleSelectedRow: handleRowClick,
                error: !!usersError,
                showRowPointer: true
              })}
            </TableWrapper>
            <PaginationWrapper rowStart='5' rowEnd='5' columnStart='1' columnEnd='12'>
              {tablelist.lengyh > 0
              && (
              <PaginationGroup
                deviceName={deviceName}
                pages={pages}
                itemSelected={itemSelected}
                handleClickPaginationItem={n => handleClickPaginationItem(
                  n, activeFilters, selectedOption.value, getUsers, setItemSelected
                )}
                options={rowsPerPage}
                selectedOption={selectedOption}
                handleDropdownChange={handleDropdownChange}
                totalItems={totalItems}
                itemsPerPage={tablelist.length}
              />
              )}
            </PaginationWrapper>
            <Toast
              title={messageToast.title}
              message={messageToast.message}
              color={messageToast.color}
              icon={messageToast.icon}
              isShowing={isShowing}
              position={TOAST_POSITION.rightTop}
              onClick={handleToastClose}
              timeOut={messageToast.title === TOAST_PROPERTIES.ERROR.title ? 3000 : 2000}
            />
            <Modal
              isShowing={open}
              close={handleCloseModal}
              title='Agregar Usuario'
              minHeight='380px'
            >
              {addUserModal && (<AddUserModal {...addUserModal} />)}
            </Modal>
          </Wrapper>
        )}
    </>
  )
}

export default Users
